export const ResultCode = {
  RequiresManualCheck: -4,
  InvalidValue: -3,
  IncorrectClassification: -2,
  JunkValue: -1,
  Empty: 0,
  Cleaned: 1,
  ValidValue: 2,
} as const;

export type ResultCodeValue = (typeof ResultCode)[keyof typeof ResultCode];

export const getResultCodeLabel = (code: number): string => {
  switch (code) {
    case ResultCode.RequiresManualCheck:
      return "Requires Manual Check";
    case ResultCode.InvalidValue:
      return "Invalid Value";
    case ResultCode.IncorrectClassification:
      return "Incorrect Classification";
    case ResultCode.JunkValue:
      return "Junk Value";
    case ResultCode.Empty:
      return "Empty";
    case ResultCode.Cleaned:
      return "Cleaned";
    case ResultCode.ValidValue:
      return "Valid Value";
    default:
      return `Code ${code}`;
  }
};

export const getResultCodeColor = (
  code: number,
): "success" | "warning" | "error" | "info" => {
  switch (code) {
    case ResultCode.Cleaned:
    case ResultCode.ValidValue:
      return "success";
    case ResultCode.RequiresManualCheck:
      return "warning";
    case ResultCode.InvalidValue:
    case ResultCode.IncorrectClassification:
    case ResultCode.JunkValue:
      return "error";
    case ResultCode.Empty:
      return "info";
    default:
      return "info";
  }
};

export const isSuccessResult = (code: number): boolean => {
  return code === ResultCode.Cleaned || code === ResultCode.ValidValue;
};
